/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const appointmentPageDayTotalsMinOne = 0
export const appointmentPageDayTotalsMaxOne = 9007199254740991

export const appointmentPageItemsItemBookedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentPageItemsItemConflictsItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentPageItemsItemConflictsItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentPageItemsItemDurationMinutesMin = -9007199254740991
export const appointmentPageItemsItemDurationMinutesMax = 9007199254740991

export const appointmentPageItemsItemEndAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentPageItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const appointmentPageItemsItemLocationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const appointmentPageItemsItemPfMessageOneAttemptsMin = 0
export const appointmentPageItemsItemPfMessageOneAttemptsMax = 9007199254740991

export const appointmentPageItemsItemPfMessageOneSentAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentPageItemsItemProviderIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const appointmentPageItemsItemSourceOneRegExp = new RegExp('^[a-z0-9_-]{1,40}$')
export const appointmentPageItemsItemStartAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentPageItemsItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const appointmentPageItemsItemVisitTypeIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const appointmentPagePageMax = 9007199254740991

export const appointmentPagePageSizeMax = 100

export const appointmentPageTotalMin = 0
export const appointmentPageTotalMax = 9007199254740991

export const AppointmentPage = zod.object({
  dayTotals: zod
    .record(zod.string(), zod.int().min(appointmentPageDayTotalsMinOne).max(appointmentPageDayTotalsMaxOne))
    .optional(),
  items: zod.array(
    zod.object({
      bookedAt: zod.iso.datetime({ offset: true }).regex(appointmentPageItemsItemBookedAtRegExp),
      conflicts: zod.array(
        zod.object({
          end: zod.iso.datetime({ offset: true }).regex(appointmentPageItemsItemConflictsItemEndRegExp),
          kind: zod.enum(['appointment', 'blocked']),
          location: zod.string(),
          reason: zod.string(),
          start: zod.iso.datetime({ offset: true }).regex(appointmentPageItemsItemConflictsItemStartRegExp),
        }),
      ),
      coverage: zod.object({
        code: zod.string(),
        name: zod.string(),
      }),
      durationMinutes: zod
        .int()
        .min(appointmentPageItemsItemDurationMinutesMin)
        .max(appointmentPageItemsItemDurationMinutesMax),
      endAt: zod.iso.datetime({ offset: true }).regex(appointmentPageItemsItemEndAtRegExp),
      id: zod.uuid().regex(appointmentPageItemsItemIdRegExp),
      location: zod.object({
        id: zod.uuid().regex(appointmentPageItemsItemLocationIdRegExp),
        name: zod.string(),
      }),
      pfAppointmentId: zod.string(),
      pfMessage: zod.union([
        zod.object({
          attempts: zod
            .int()
            .min(appointmentPageItemsItemPfMessageOneAttemptsMin)
            .max(appointmentPageItemsItemPfMessageOneAttemptsMax),
          lastErrorCode: zod.string().nullable(),
          sentAt: zod.union([
            zod.iso.datetime({ offset: true }).regex(appointmentPageItemsItemPfMessageOneSentAtOneRegExp),
            zod.null(),
          ]),
          status: zod.enum(['pending', 'sending', 'sent', 'failed', 'skipped']),
        }),
        zod.null(),
      ]),
      provider: zod.object({
        color: zod.string(),
        credentials: zod.string(),
        id: zod.uuid().regex(appointmentPageItemsItemProviderIdRegExp),
        name: zod.string(),
      }),
      source: zod.union([zod.string().regex(appointmentPageItemsItemSourceOneRegExp), zod.null()]),
      sourceSaved: zod.boolean(),
      startAt: zod.iso.datetime({ offset: true }).regex(appointmentPageItemsItemStartAtRegExp),
      startDate: zod.string().regex(appointmentPageItemsItemStartDateRegExp),
      visitType: zod.object({
        id: zod.uuid().regex(appointmentPageItemsItemVisitTypeIdRegExp),
        name: zod.string(),
        telehealth: zod.boolean(),
      }),
    }),
  ),
  page: zod.int().min(1).max(appointmentPagePageMax),
  pageSize: zod.int().min(1).max(appointmentPagePageSizeMax),
  total: zod.int().min(appointmentPageTotalMin).max(appointmentPageTotalMax),
})

export type AppointmentPage = zod.input<typeof AppointmentPage>
export type AppointmentPageOutput = zod.output<typeof AppointmentPage>
